<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/maintenance_histories/_form.vue';
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
  mixins: [StoreForm],
  components: {App, Form},
  props: ['product'],
  data() {
    return {
      formRoute: route('api.v1.products.maintenance_histories.store', {'product': this.product}),
      redirectRoute: route('products.maintenance_histories.index', {'product': this.product}),
      stayOnPageRedirect: route('products.maintenance_histories.edit', {maintenance_history: '_id_', 'product': this.product}),
    }
  },
}
</script>

<template>
  <App title="Onderhoudshistorie toevoegen">
    <form id="maintenanceHistoryForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          form-id="maintenanceHistoryForm"
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>